module.exports = __webpack_public_path__ + "img/RBS04_1_loading.59a296d7.jpg";